import React from 'react';
import { useEditorActions } from '../../store/editorStore.jsx';

export function SpacerCanvas({ block }) {
  const height = block.attrs.height || 32;
  return (
    <div
      className="editor-spacer-block d-flex align-items-center justify-content-center"
      style={{ height, userSelect: 'none', opacity: 0.3, borderTop: '1px dashed #ccc', borderBottom: '1px dashed #ccc' }}
    >
      <small className="text-muted" style={{ fontSize: '0.7rem', letterSpacing: 1 }}>
        SPACER {height}px
      </small>
    </div>
  );
}

export function SpacerInspector({ block }) {
  const { updateAttrs } = useEditorActions();
  const height = block.attrs.height || 32;

  return (
    <div className="p-3">
      <div className="mb-3">
        <label className="form-label fw-semibold small">Height (px)</label>
        <input
          type="range"
          className="form-range"
          min={8}
          max={200}
          step={4}
          value={height}
          onChange={(e) => updateAttrs(block.id, { height: Number(e.target.value) })}
        />
        <small className="text-muted">{height}px</small>
      </div>
    </div>
  );
}
